import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/app/store";
import {
  selectIsAuthenticated,
  selectIsLoading,
} from "@/app/store/slices/auth.slice";

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * Protects routes that require authentication
 * Redirects to login if user is not authenticated
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isLoading = useAppSelector(selectIsLoading);

  // Show nothing while checking auth status
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 " />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
